// @see https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types#image_types
export const UPLOAD_ACCEPTED_FILE_TYPES_IMAGES = [
  "image/jpg",
  "image/jpeg",
  "image/png",
  "image/heic",
]

export const UPLOAD_ACCEPTED_FILE_TYPES_DOCUMENTS = [
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
]
